export interface InvoiceFilters {
  transaction_type: string;
  service_type: string;
  date_from: string;
  date_to: string;
}

export const buildUnifiedTransactionFilters = (
  filters: InvoiceFilters,
): Record<string, string> => {
  const params: Record<string, string> = {};

  if (filters.transaction_type) {
    params.transaction_type = filters.transaction_type;
  }

  if (filters.service_type) {
    params.service_type = filters.service_type;
  }

  if (filters.date_from) {
    params.date_from = filters.date_from;
  }

  if (filters.date_to) {
    params.date_to = filters.date_to;
  }

  return params;
};
